import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import config from "@/api/base.js";
Vue.use(Vuex)

const store =new Vuex.Store({
	state:{
		certTest:{},                              //证书查验
		xsMsg:{},                                 //学时证明信息
		addrNum:"",              				  //地区选择组件选择的地区编号
		codeNum:0,               				  //验证码刷新
		showBackBtn:true,        				  //头部是否显示返回按钮
		backToMember:false,						  //返回个人中心
		navOnBottomStatus:[],    				  //底部导航栏显示状态
		checkBoxAll:false,       				  //设置多选框全选状态   默认false取消全选 
		clickCheckBoxAll:false,  				  //多选框状态单独设置 
		chooseCity:'',                            //选择的城市
		needPay:'0',                              //需要支付的价格  
		chooseMajor:"",                           //选择的专业  
    CODEID:'',//地区id
    CITYNAME:'',//地区Name
    logo: {}, //头部数据
	},
	getters:{
		// 证书模块
		zsData(state){
			// 将证书的数据取出并且转化为对象
			if(state.certTest == "")
				return JSON.parse(state.certTest)
			else
				return JSON.parse(sessionStorage.getItem("zsData"));
		},
		xsData(state){
			// 将证书的数据取出并且转化为对象
			if(state.xsMsg == "" || state.xsMsg == null)
				return JSON.parse(state.xsMsg)
			else
				return JSON.parse(sessionStorage.getItem("xsMsg"));
		}
	},
	mutations:{
    UPDATA_CODEID(state, CODEID) {
      state.CODEID = CODEID;
    },
    UPDATA_CITYNAME(state, CITYNAME) {
      state.CITYNAME = CITYNAME;
    },
    HEAD_LOGO: (state, logo) => {
      state.logo = logo;
    },
		// 证书模块
		zsSave(state,data){
			state.certTest=data;
			// 将数据存在localstorage，防止刷新没有数据
			sessionStorage.setItem("zsData",data);
		},
		xsSave(state,data){
			state.xsMsg=data;
			// 将数据存在localstorage，防止刷新没有数据
			sessionStorage.setItem("xsMsg",data);
		},

		// 地区选择
		addrSelectSave(state,data){
			state.addrNum=data;
		},
		
		//验证码刷新
		codeFresh(state){
			state.codeNum++;
		},

		//头部是否显示返回按钮，默认显示
		showHeaderBack(state,data){
			state.showBackBtn=data;
		},
		//头部是否返回个人中心
		setBackToMember(state,data){
			state.backToMember=data;
		},

		// 设置底部导航栏状态
		setNavOnBottomStatus(state,data){
			state.navOnBottomStatus=data;
		},

		// 设置多选框是否全选
		setCheckBoxAll(state,data){
			state.checkBoxAll=data;
		},
		setClickCheckBoxAll(state,data){
			state.clickCheckBoxAll=data;
		},

		//设置选中的城市
		setChooseCity(state,data){
			state.chooseCity=data;
		},

		//需要支付的价格
		setNeedPay1(state,data){
			state.needPay=data;
		},

		//选择的专业
		setMajor(state,data){
			state.chooseMajor=data;
		}
	},
  actions:{
    getSubUrl({ commit, state }) {
      
      
      let data = {
        token: localStorage.getItem('token') || ''
      };
      return new Promise((resolve, reject) => {
        axios.post("/subUrl.html", data, config).then(res => {
            console.log(res);
            commit('HEAD_LOGO', res.data.info.URL);
            commit('UPDATA_CODEID', res.data.info.CODEID);
            commit('UPDATA_CITYNAME', res.data.info.CITYNAME);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js